import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoSwitchMixin from './KendoSwitchMixin'

export default {
    name: 'kendo-switch',
    mixins: [ KendoSwitchMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        if(this.v3) {
            return h('input',{
                type: 'checkbox'
            })
        } else {
            return h('input',{
                attrs: {
                    type: 'checkbox'
                }
            })
        }
       
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/index.js